<template>
  <a-form :form="form" class="commonForm">
    <div class="commonFormTitle" :class="!canEdit?'commonFormDetailTitle':''" v-if="formTitle">{{formTitle}}
      <span v-if="canDelete && canEdit" style="float:right;cursor:pointer;font-size:14px;color: #0295EE;" @click="deleteDetail">删除</span>
    </div>
    <a-form-item v-bind="formItemLayout" v-for="config in formConfig.contents" :key="config.field" :label="config.label" v-if="config.show && formConfig.contents.length>0">
      <span v-if="typeof formParamsInit[config.field] === 'string' && config.type==='text'" style="word-break: break-all;word-wrap: break-word;">
        {{ formParamsInit[config.field].substr(0, formTextInfoAllShow[config.field] !== true ? maxTextInfoLength : formParamsInit[config.field].length) }}
        <span v-if="formTextInfoAllShow[config.field] !== true && formParamsInit[config.field].length > maxTextInfoLength">
          ...
          <a class="form-text-info-more" href="javascript:;" @click.stop="formTextInfoMore(config.field)">展开详情</a>
        </span>
      </span>
     
      <span v-if="typeof formParamsInit[config.field] !== 'string' && config.type==='text'">
        {{ formParamsInit[config.field]?formParamsInit[config.field]:undefined }}
      </span>
      
      <span v-if="config.type==='html'">
        <span v-html="formParamsInit[config.field]">{{formParamsInit[config.field]}}</span>
      </span>
      
      <a-input type="text" v-if="config.type==='input'" :maxLength="config.maxLength?config.maxLength:100" :disabled="config.disabled" :placeholder="config.placeholder?config.placeholder:'请输入'" v-decorator="[config.field,
      { rules: [{ required:config.required?true:false, message: '信息不能为空!' },{pattern:config.number === true?new RegExp(/^\d{1,}$/):false,message:`${config.label}需要是纯数字组合!`}],
      initialValue:params[config.field]?params[config.field]:undefined },]"></a-input>
      
      <a-input-number v-if="config.type==='number'" :disabled="config.disabled" v-decorator="[
          config.field,
          {rules: [{type: 'number',message: '请输入数字!',},{required: config.required?true:false,message: '信息不能为空!'},{validator:checkIsInt.bind(this)},],
          initialValue:params[config.field]?(typeof params[config.field]==='string'?moneyFormatNumber(params[config.field],config):Number(params[config.field])):(config.defaultVal?Number(config.defaultVal):undefined)},
        ]" :placeholder="config.placeholder?config.placeholder:'请输入'" style="width:100%;" :formatter="limitDecimals" :parser="limitDecimals" :max="config.maxValue?config.maxValue:undefined" />
     
      <div v-if="config.type==='select'" class="common-form-select">
        <a-select type="text" :allowClear="true" :disabled="config.disabled" :loading="!config.optionInitFinished" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '信息不能为空!' }],
      initialValue:config.optionInitFinished && params[config.field] && config.selectObj?params[config.field]:undefined },]" :placeholder="config.placeholder?config.placeholder:'请选择'" showSearch :filterOption="selectFilterOption" @change="value => onSelected(value, config)">
          <a-select-option :value="option.id" v-for="(option,index) in config.options" :key="index">{{option.name}}</a-select-option>
        </a-select>
        <span v-if="config.selectObj && config.selectObj.notice" style="color:#f5222d">{{config.selectObj.notice}}</span>
        <a-tooltip v-if="config.optionInstructions || setDefaulInstructions(params[config.field],config)">
          <template slot="title">
            <span>{{config.optionInstructions}}</span>
          </template>
          <span style="font-size:14px;color:#1890ff;cursor:pointer">{{config.selectOptionName}}填写说明</span>
        </a-tooltip>
      </div>

      <a-radio-group v-if="config.type==='radio'" :disabled="config.disabled" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '信息不能为空!' }],
      initialValue:params[config.field]?params[config.field]:undefined },]">
        <a-radio :value="option.id" :disabled="option.disabled" v-for="(option,index) in config.options" :key="index">{{option.name}}</a-radio>
      </a-radio-group>

      <a-date-picker v-if="config.type==='datePicker'" :disabled="config.disabled" :disabledDate="current=>getDisabledDate(current,config)" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '信息不能为空!' }],
      initialValue:params[config.field]?moment(params[config.field]):undefined },]" :class="isNomalDate(moment(config.value),config.compare)?'':'warn'"></a-date-picker>
      
      <a-range-picker v-if="config.type==='rangePicker'" :showTime="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" :placeholder="['开始时间', '结束时间']" :disabledDate="current=>getDisabledDate(current,config)" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '时间不能为空!' }],
      initialValue:params[config.field]?setRangePickerVal(params[config.field]):undefined},]" :class="isMulNomalDate(config.value,config.compare)?'':'warn'" />
      
      <a-textarea :style="config.height?setTextAreaHeight(config.height):''" v-if="config.type==='textArea'" :maxLength="config.maxLength?config.maxLength:100" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '信息不能为空!' }],
      initialValue:params[config.field]?params[config.field]:undefined },]" :placeholder="config.placeholder?config.placeholder:'请输入'"></a-textarea>
      
      <a-upload v-if="config.type==='upload'" class="upload-list-inline" listType="picture" :class="canEdit?'':'upload-list-detail'" name="file" :remove="file=>handleRemove(file,config)" :before-upload="file=>beforeUpload(file,config)" :default-file-list="setDefaultFileList(params[config.field],config)" :file-list="fileList[config.field]" accept=".png,.jpg,.jpeg,.ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam" :multiple="true" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '附件不能为空!' }],
      initialValue:params[config.field]?initUploadValue(params[config.field],config):[]}]">
        <a-button v-if="canEdit">
          <a-icon type="upload" />上传</a-button>
      </a-upload>

      <!-- <multi-datepicker v-if="config.type==='multiDatepicker'" :config="config" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '日期不能为空!' }],
      initialValue:params[config.field]?params[config.field]:[]},]" :params="params[config.field]?params[config.field]:[]" @get-multidate="getMultiDate($event,config)"></multi-datepicker> -->
      
      <dates-picker v-if="config.type==='multiDatepicker'" :config="config" v-decorator="[config.field,
      { rules: [{ required: config.required?true:false, message: '日期不能为空!' }],
      initialValue:params[config.field]?params[config.field]:[]},]" :select-result="params[config.field]?params[config.field]:[]" :max-date="getMaxDate(config)" @get-multidate="getMultiDate($event,config)"></dates-picker>
      
      <span class="has-sample" @click="showSample(config.sampleUrlName)" v-if="config.hasSample">行程单票价示例</span>

      
      <div style="font-size: 14px;color: #FF4D07;" v-if="config.type==='datePicker' && !isNomalDate(moment(config.value),config.compare)">{{config.compare.message}}</div>
      <div style="font-size: 14px;color: #FF4D07;" v-if="config.type==='rangePicker' && !isMulNomalDate(config.value,config.compare)">{{config.compare.message}}</div>
      
      <p class="init-message" v-if="config.init && config.init.length" v-for="(item,index) in config.init" :key="'init'+index">{{item.message}}</p>

      <a-tooltip v-if="config.instructionTitle">
        <template slot="title">
          <span>{{config.instruction}}</span>
        </template>
        <span style="font-size:14px;color:#1890ff;cursor:pointer">{{config.instructionTitle}}</span>
      </a-tooltip>

    </a-form-item>
    <div style="text-align:center" v-if="formConfig.contents.length === 0">
      <a-spin tip="数据加载中..."></a-spin>
    </div>
    <a-modal :visible="sampleModalShow" class="sampleModal" @cancel="sampleModalShow=false" :width="670">
      <img :src="sampleUrlName" width="100%" height="auto" />
    </a-modal>
  </a-form>
</template>

<script>
import LayoutConfig from "../utils/LayoutConfig.js";
import CascaderManager from "../utils/CascaderManager.js";
import { checkIsImage, moneyToNumValue } from "../utils/tools.js";
import moment from "moment";
import lodash from "lodash";
import { commonFromUploadApi } from "../services/CommonService.js";

import MultiDatepicker from "./MultiDatepicker.vue";
import DatesPicker from "./DatesPicker.vue";
const MAX_TEXT_INFO_LENGTH = 60;

export default {
  props: {
    layout: Object,
    params: {
      default: {},
      type: Object
    },
    formTitle: String,
    canDelete: Boolean,
    canEdit: Boolean,
    needId: Boolean, // 用于区分复制或修改是否需要传参数id
    fieldPath: {
      type: String,
      default: undefined
    }
  },
  components: {
    MultiDatepicker,
    DatesPicker
  },
  data() {
    return {
      allOptionInitFinished: false,
      sampleModalShow: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 6 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 14 },
          sm: { span: 10 }
        }
      },
      sampleUrlName: undefined,
      isFieldChange: false,
      formConfig: Object.assign({}, this.layout),
      formParamsInit: {},
      limitDecimals: value => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        if (typeof value === "string") {
          return !isNaN(Number(value))
            ? value.replace(reg, "$1$2.$3")
            : value.substr(0, value.length - 1);
        } else if (typeof value === "number") {
          return !isNaN(value)
            ? String(value).replace(reg, "$1$2.$3")
            : String(value).substr(0, value.length - 1);
        } else {
          return "";
        }
      },
      maxTextInfoLength: MAX_TEXT_INFO_LENGTH,
      formTextInfoAllShow: {},
      vmFieldPath: this.layout.field ? this.layout.field : this.fieldPath,
      fileList: {}
    };
  },
  beforeCreate() {},
  created() {
    let vm = this;
    this.instance = this;
    this.formConfig.contents.forEach(item => {
      if (item.type === "upload") {
        let newFiles = [];
        if (this.params[item.field] && this.params[item.field].length > 0) {
          newFiles = this.params[item.field].map(e => {
            return {
              id: e.id,
              name: e.name,
              uid: e.id,
              url: e.url,
              thumbUrl: checkIsImage(e.name)
                ? "/images/file-image.svg"
                : "/images/file-default.svg"
            };
          });
        }
        this.$set(this.fileList, item.field, newFiles);
      }
    });
    this.form = this.$form.createForm(this, {
      onFieldsChange: (_, changedFields) => {
        if (this.isValidate) {
          return;
        }
        if (Object.keys(changedFields).length === 0) {
          return;
        }
        const fieldName = Object.keys(changedFields)[0];
        let config = LayoutConfig.getConfigByField(
          this.formConfig.contents,
          fieldName
        );
        if (config.type === "upload") {
          // 上传附件不采用此种方式传递emit,而是通过beforeUpload，handleChange事件
          return;
        }
        if (changedFields[fieldName].validating) {
          if (config.type === "select" && config.options) {
            // selectObj属性用于联动valueBind，例如选择付款银行账号后联动是否结汇的显示
            config.selectObj = config.options.find(
              item => item.id === changedFields[fieldName].value
            );
          }
          if (config.type === "datePicker") {
            vm.isNomalDate(changedFields[fieldName].value, config.compare);
          }
          config.value = changedFields[fieldName].value;
          this.isFieldChange = true;
          new Promise(function(resolve, reject) {
            if (config.trigger) {
              CascaderManager.triggerCascader(config.trigger, config, vm);
            }
            resolve();
          }).then(function() {
            let formParams = lodash.cloneDeep(vm.form.getFieldsValue());
            vm.formConfig.contents.forEach((item, index) => {
              // 下拉选项请求完成之前不改变值
              if (
                !item.optionInitFinished &&
                (item.type === "select" || item.type === "radio")
              ) {
                formParams[item.field] = vm.params[item.field];
              }
              if (moment.isMoment(formParams[item.field])) {
                formParams[item.field] = moment(formParams[item.field]).format(
                  "YYYY-MM-DD"
                );
              }
              if (item.type === "rangePicker" && formParams[item.field]) {
                let newRangeVal = [];
                formParams[item.field].forEach(item => {
                  newRangeVal.push(item.format("YYYY-MM-DD HH:mm"));
                });
                formParams[item.field] = newRangeVal;
              }
              if (
                item.type === "number" &&
                (formParams[item.field] || formParams[item.field] === 0)
              ) {
                formParams[item.field] = Number(formParams[item.field]).toFixed(
                  2
                );
              }
              if (item.type === "upload") {
                formParams[item.field] = (lodash.isArray(formParams[item.field])
                  ? formParams[item.field]
                  : formParams[item.field].fileList
                ).map(item => {
                  return {
                    name: item.originFileObj
                      ? item.originFileObj.name
                      : item.name,
                    id: item.originFileObj ? item.originFileObj.uid : item.uid,
                    uid: item.originFileObj ? item.originFileObj.uid : item.uid,
                    url: item.originFileObj ? item.originFileObj.url : item.url,
                    thumbUrl: checkIsImage(
                      item.originFileObj ? item.originFileObj.name : item.name
                    )
                      ? "/images/file-image.svg"
                      : "/images/file-image.svg"
                  };
                });
              }
              if (!item.show) {
                delete formParams[item.field];
              }
            });

            let emitParams = {};

            const requiredTextConfig = vm.formConfig.contents.filter(item => {
              return item.type === "text" && item.required;
            });
            if (vm.formConfig.field) {
              // commonForm会带field
              emitParams[vm.formConfig.field] = formParams;
              if (vm.formParamsInit.id && vm.needId) {
                emitParams[vm.formConfig.field].id = vm.formParamsInit.id;
              }
              requiredTextConfig.forEach(item => {
                emitParams[vm.formConfig.field][item.field] =
                  vm.formParamsInit[item.field];
              });
            } else {
              // 从属于multiForm的commonForm不带field
              emitParams = formParams;
              if (vm.formParamsInit.id && vm.needId) {
                emitParams.id = vm.formParamsInit.id;
              }
              requiredTextConfig.forEach(item => {
                emitParams[item.field] = vm.formParamsInit[item.field];
              });
            }
            LayoutConfig.setSameLevelParams(emitParams);
            vm.$emit("changed-fields", emitParams);
            vm.$emit("current-changed-field", {
              ...changedFields,
              selectObj: config.selectObj,
              isFromBasciInfo: vm.formConfig.field ? true : false
            });
          });
        }
      }
    });
  },
  mounted() {
    this.$EventBus.$on("setTargetFormVm", obj => {
      if (obj.targetFieldPath.indexOf(this.vmFieldPath) !== -1) {
        obj.triggerVm.targetVm = this;
      }
    });
    
    this.formParamsInit = Object.assign({}, this.formParamsInit, this.params);
    this.dispfetchByConfig(this.formConfig.contents);
    LayoutConfig.setSameLevelParams(this.params); // 涉及同级组件联动时的参数

    let paramsBackup = _.cloneDeep(this.params); // 提交请求时不传text类型的数值
    Object.keys(this.params).forEach(key => {
      const config = this.formConfig.contents.find(item => item.field === key);
      if (
        (config &&
          (!config.show ||
            config.type === "text" ||
            config.type === "html" ||
            (config.type === "upload" && !this.canEdit))) ||
        (!config && key !== "id")
      ) {
        delete paramsBackup[key];
      }
      if (
        config &&
        config.type === "number" &&
        (paramsBackup[key] || paramsBackup[key] === 0)
      ) {
        paramsBackup[key] =
          typeof paramsBackup[key] === "string"
            ? this.moneyFormatNumber(paramsBackup[key]).toFixed(2)
            : Number(paramsBackup[key]).toFixed(2);
      }
    });
    let emitParams = {};
    if (!this.needId && this.params.id) {
      if (this.formConfig.field) {
        emitParams[this.formConfig.field] = _.cloneDeep(paramsBackup);
        delete emitParams[this.formConfig.field].id;
      } else {
        emitParams = _.cloneDeep(paramsBackup);
        delete emitParams.id;
      }
    } else {
      if (this.formConfig.field) {
        emitParams[this.formConfig.field] = _.cloneDeep(paramsBackup);
      } else {
        emitParams = _.cloneDeep(paramsBackup);
      }
    }
    if (
      Object.keys(paramsBackup).length === 1 &&
      Object.keys(paramsBackup)[0] === "id"
    ) {
      return;
    } else {
      this.$emit("changed-fields", emitParams);
    }
  },

  computed: {},

  methods: {
    moment,
    moneyFormatNumber(val, config) {
      let num = Number(moneyToNumValue(val));
      return num;
    },

    dispfetchByConfig(configs) {
      for (let index = 0; index < configs.length; index++) {
        configs[index].optionInitFinished = false;
        if (configs[index].type === "text") {
          configs[index].value = configs[index].value
            ? configs[index].value
            : this.params[configs[index].field];
        } else {
          configs[index].value = this.params[configs[index].field];
        }
        // 触发联动
        if (configs[index].trigger && configs[index].show) {
          CascaderManager.triggerCascader(
            configs[index].trigger,
            configs[index],
            this
          );
        }
        // 发请求get options
        if (
          configs[index].fetch &&
          configs[index].fetch.url &&
          configs[index].type !== "upload"
        ) {
          
          if(configs[index].fetch.url == 'api/fas/reimburse/actual-applier-option') {
            setTimeout(() => {
              this.fetchOptions(configs[index], index);
            }, 1000);
          } else {
            this.fetchOptions(configs[index], index);
          }
        } else if (
          lodash.isArray(configs[index].contents) &&
          configs[index].contents.length > 0
        ) {
          this.dispfetchByConfig(configs[index].contents);
        }
      }
    },

    fetchOptions(config, index) {
      LayoutConfig.dispfetchByConfig(this, this.formConfig.contents, config)
        .then(res => {
          if (res.status === "success") {
            config.selectObj = res.data.find(item => item.id === config.value);
            config.optionInitFinished = true;
            let newConfig = _.cloneDeep(config);
            newConfig.options = res.data;
            this.$set(this.formConfig.contents, index, newConfig);
            if (config.trigger && config.show) {
              CascaderManager.triggerCascader(config.trigger, config, this);
            }
          } else {
            config.optionInitFinished = true;
            this.$Message.error(res.message);
          }
        })
        .catch(error => {
          config.optionInitFinished = true;
        });
    },

    refreshOptionsByField(field, params) {
      let formParams = this.form.getFieldsValue();
      formParams[field] = undefined;
      this.form.setFieldsValue(formParams);
      let config = LayoutConfig.getConfigByField(
        this.formConfig.contents,
        field
      );
      if (config.optionInstructions) {
        this.$set(config, "optionInstructions", "");
        this.$set(config, "selectOptionName", "");
      }
      LayoutConfig.dispfetchByConfig(
        this,
        this.formConfig.contents,
        config,
        params
      )
        .then(res => {
          if (res.status === "success") {
            config.options = res.data;
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(error => {});
    },
    validateFields() {
      if (!this.optionInit) return false; // 所有的下拉选项初始结束后才可以点击提交
      this.isValidate = true;
      let checkResult = false;
      this.form.validateFields((err, values) => {
        if (!err) {
          checkResult = true;
        } else {
          checkResult = false;
        }
      });
      this.isValidate = false;
      return checkResult;
    },
    updateLayout(config) {
      this.$emit("update", this.form.getFieldValue(config.field));
    },
    deleteDetail() {
      this.$emit("delete-detail");
    },
    selectFilterOption(input, option) {
      return option.componentOptions.children[0].text.includes(input);
    },
    onSelected(e, config) {
      let selectObj = config.options.find(item => item.id === e);
      if (selectObj && selectObj.explain) {
        this.$set(config, "optionInstructions", selectObj.explain);
        this.$set(config, "selectOptionName", selectObj.name);
      } else {
        this.$set(config, "optionInstructions", "");
        this.$set(config, "selectOptionName", "");
      }
      if (config.eventRelays) {
        let relayParams = {};
        relayParams[config.field] = e;
        this.eventRelay(config.eventRelays, relayParams);
      }
    },
    eventRelay(eventRelays, relayParams = {}) {
      const self_event = eventRelays[0];
      let behind_event = _.cloneDeep(eventRelays);
      behind_event.shift();
      behind_event.forEach(item => {
        item.relayParams = relayParams;
      });
      if (self_event.selfDo === "emit") {
        this.$emit("event-relay", behind_event);
      } else if (self_event.selfDo === "refreshOptionsByField") {
        this.refreshOptionsByField(
          self_event.params.value,
          self_event.relayParams
        );
      }
    },
    clearByField(field) {
      if (!this.isFieldChange) {
        return; //页面渲染初始化不联动,仅当字段值改变时联动
      }
      let config = this.formConfig.contents.find(item => item.field === field);
      config.value = undefined;
      if (config.type === "text") {
        this.formParamsInit[field] = undefined;
      } else {
        let formParams = this.form.getFieldsValue();
        formParams[field] = undefined;
        this.form.setFieldsValue(formParams);
      }
    },
    setDefaultFileList(list, config) {
      if (config.hasSet) {
        //只在初始加载的时候进行设置默认文件列表
        return;
      }
      let defaultFileList = [];
      config.hasSet = true;
      if (list) {
        defaultFileList = list.map(item => {
          return {
            ...item,
            uid: item.id,
            url: item.url,
            thumbUrl: checkIsImage(item.name)
              ? "/images/file-image.svg"
              : "/images/file-default.svg"
          };
        });
      }
      return defaultFileList;
    },

    initUploadValue(list, config) {
      let listCopy = _.cloneDeep(list);
      let defaultFileList = [];
      if (!_.isArray(list)) {
        defaultFileList = list.fileList.map(item => {
          return {
            name: item.originFileObj ? item.originFileObj.name : item.name,
            id: item.originFileObj ? item.originFileObj.uid : item.uid,
            uid: item.originFileObj ? item.originFileObj.uid : item.uid,
            url: item.originFileObj ? item.originFileObj.url : item.url,
            thumbUrl: checkIsImage(
              item.originFileObj ? item.originFileObj.name : item.name
            )
              ? "/images/file-image.svg"
              : "/images/file-image.svg"
          };
        });
      } else {
        defaultFileList = list.map(item => {
          return {
            name: item.name,
            id: item.id,
            uid: item.id,
            thumbUrl: checkIsImage(item.name)
              ? "/images/file-image.svg"
              : "/images/file-image.svg",
            url: item.url
          };
        });
      }
      return defaultFileList;
    },

    getMultiDate(e, config) {
      config.value = e;
      let currentFormParams = this.form.getFieldsValue();
      currentFormParams[config.field] = e;
      this.form.setFieldsValue(currentFormParams);
      CascaderManager.triggerCascader(config.trigger, config, this);
      this.setEmitParams();
    },

    setEmitParams() {
      let vm = this;
      let formParams = lodash.cloneDeep(vm.form.getFieldsValue());
      vm.formConfig.contents.forEach((item, index) => {
        if (moment.isMoment(formParams[item.field])) {
          formParams[item.field] = moment(formParams[item.field]).format(
            "YYYY-MM-DD"
          );
        }
        if (item.type === "rangePicker" && formParams[item.field]) {
          let newRangeVal = [];
          formParams[item.field].forEach(item => {
            newRangeVal.push(item.format("YYYY-MM-DD HH:mm"));
          });
          formParams[item.field] = newRangeVal;
        }
        if (item.type === "number" && formParams[item.field]) {
          formParams[item.field] = Number(formParams[item.field]).toFixed(2);
        }
        if (item.type === "upload") {
          formParams[item.field] = formParams[item.field] = (lodash.isArray(
            formParams[item.field]
          )
            ? formParams[item.field]
            : formParams[item.field].fileList
          ).map(item => {
            return {
              name: item.originFileObj ? item.originFileObj.name : item.name,
              id: item.originFileObj ? item.originFileObj.uid : item.uid,
              uid: item.originFileObj ? item.originFileObj.uid : item.uid,
              url: item.originFileObj ? item.originFileObj.url : item.url,
              thumbUrl: checkIsImage(
                item.originFileObj ? item.originFileObj.name : item.name
              )
                ? "/images/file-image.svg"
                : "/images/file-image.svg"
            };
          });
        }
        if (!item.show) {
          delete formParams[item.field];
        }
      });
      let emitParams = {};

      if (vm.formConfig.field) {
        // commonForm会带field
        emitParams[vm.formConfig.field] = formParams;
        if (vm.formParamsInit.id && vm.needId) {
          emitParams[vm.formConfig.field].id = vm.formParamsInit.id;
        }
      } else {
        // 从属于multiForm的commonForm不带field
        emitParams = formParams;
        if (vm.formParamsInit.id && vm.needId) {
          emitParams.id = vm.formParamsInit.id;
        }
      }
      vm.$emit("changed-fields", emitParams);
    },

    showSample(sampleUrlName) {
      this.sampleModalShow = true;
      this.sampleUrlName = require(`../assets/${sampleUrlName}.png`);
    },

    isNomalDate(selectedDate, compare) {
      return LayoutConfig.isNomalDate(selectedDate, compare);
    },

    isMulNomalDate(selectedDate, compare) {
      if (lodash.isArray(selectedDate) && selectedDate[0]) {
        return LayoutConfig.isNomalDate(moment(selectedDate[0]), compare);
      }
      return true;
    },

    setRangePickerVal(data) {
      let arr = [];
      let status = data.every(item => item);
      if (status) {
        data.forEach(item => {
          arr.push(moment(item));
        });
      }
      return arr;
    },

    setDefaulInstructions(value, config) {
      if (!config.options) return;
      const option = config.options.find(item => item.id === value);
      let has = false;
      if (option && option.explain) {
        config.selectOptionName = option.name;
        config.optionInstructions = option.explain;
        has = true;
      }
      return has;
    },

    formTextInfoMore(field) {
      this.$set(this.formTextInfoAllShow, field, true);
    },

    setTextAreaHeight(height) {
      return `height:${height}px`;
    },

    checkIsInt(rule, value, callback) {
      let config = this.formConfig.contents.find(
        item => item.field === rule.field
      );
      if (config.isInt && Number(value) % 1 !== 0) {
        callback("数值必须是整数");
        return;
      }
      callback();
    },

    getDisabledDate(current, config) {
      if (config.minDate) {
        const minDate = moment()
          .add(config.minDate.number, config.minDate.type)
          .endOf("day");
        return current && current < minDate;
      }
      if(config.init && config.init.length) {
        let minus = config.init[config.init.length - 1];
        let d = moment().get('date') - 1;
        let m = moment().get('month') + 1;
        if(m + (minus.number) == (4 || 6 || 9 || 11)) {
          d > 30 ? 30 : d
        } else if(m + (minus.number) == (2)) {
          d > 28 ? 28 : d
        }
        const minDate = moment()
          .add((minus.number - 1), minus.type)  // 月份要减1
          .endOf("month") + d*24*3600*1000;
        return current && current < minDate;
      }
    },

    //使用场景举例：BD团队联动预算科目值变化
    updateFieldValue(configField, value) {
      let currentFormParams = this.form.getFieldsValue();
      currentFormParams[configField] = value;
      this.form.setFieldsValue(currentFormParams);
      this.setEmitParams();
    },

    /*
     * 关于上传组件
     */
    handleRemove(file, config) {
      const index = this.fileList[config.field].findIndex(
        item => item.id === file.id
      );
      this.fileList[config.field].splice(index, 1);
      let currentFormParams = this.form.getFieldsValue();
      let delete_index = undefined;
      if (!_.isArray(currentFormParams[config.field])) {
        delete_index = currentFormParams[config.field].fileList.findIndex(e => {
          return (e.id ? e.id : e.originFileObj.uid) === file.id;
        });
        currentFormParams[config.field].fileList.splice(delete_index, 1);
      } else {
        delete_index = currentFormParams[config.field].findIndex(e => {
          return (e.id ? e.id : e.originFileObj.uid) === file.id;
        });
        currentFormParams[config.field].splice(delete_index, 1);
      }
      this.form.setFieldsValue(currentFormParams);
      this.setEmitParams();
    },

    beforeUpload(file, config) {
      const isLt10M = file.size / 1024 / 1024 <= 10;
      const currentFormParams = this.form.getFieldsValue();
      let sameNameFilesLength = currentFormParams[config.field].fileList
        ? currentFormParams[config.field].fileList.filter(
            item => item.name === file.name
          ).length
        : currentFormParams[config.field].filter(
            item => item.name === file.name
          ).length;

      if (!isLt10M) {
        this.$Message.error("单文件不能大于 10MB！");
        return false;
      }
      if (sameNameFilesLength > 0) {
        this.$Message.warning("该文件名与已上传文件名相同");
        return false;
      }
      if (isLt10M && sameNameFilesLength === 0) {
        this.handleChange(file, config);
      }
      return false;
    },

    handleChange(file, config) {
      const fileInfo = new FormData();
      fileInfo.append("fileInfo", file);
      commonFromUploadApi(config.fetch.url, fileInfo).then(res => {
        if (res.status === "success") {
          file.file_key = res.data.annexKey;
          file.uid = res.data.annexKey;
          file.url = res.data.url;
          file.thumbUrl = checkIsImage(res.data.name)
            ? "/images/file-image.svg"
            : "/images/file-default.svg";
          this.fileList[config.field].push({
            id: res.data.annexKey,
            name: file.name,
            url: file.url,
            thumbUrl: file.thumbUrl,
            uid: file.uid
          });
          this.setEmitParams();
          this.$Message.success(`${file.name}上传成功！`);
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    setFileObj(fieldName, fileList) {
      let fileObj;
      let fileListCopy = _.cloneDeep(fileList);
      fileObj = fileListCopy.map(item => {
        return {
          id: item.id,
          uid: item.id,
          name: item.name,
          url: item.url,
          thumbUrl: checkIsImage(item.name)
            ? "/images/file-image.svg"
            : "/images/file-default.svg"
        };
      });
      return fileObj;
    },

    //获取最大允许日期，例如提交的餐补日期最大为当日
    getMaxDate(config) {
      // const compare = {
      //   type: 'day',
      //   number: 0,
      // };
      let maxDate = undefined;
      if (config.compare) {
        maxDate = moment().add(config.compare.number, config.compare.type);
      }
      return maxDate;
    }
  },
  watch: {
    formConfig: {
      handler: function(val) {
        if (!this.allOptionInitFinished && !this.optionInit) {
          this.allOptionInitFinished = val.contents
            .filter(item => {
              return item.fetch && item.fetch.url && item.type !== "upload";
            })
            .every(obj => {
              return obj.optionInitFinished;
            });
          if (this.allOptionInitFinished) {
            this.optionInit = true;
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="less">
.commonForm {
  .commonFormTitle {
    margin-bottom: 24px;
  }
  .commonFormDetailTitle {
    padding: 9px 8px;
    background: #fafafa;
    border-radius: 4px;
  }
  .has-sample {
    font-size: 14px;
    color: #0295ee;
    cursor: pointer;
  }
  .ant-calendar-picker.warn .ant-input {
    border: 1px solid #e54506;
    border-radius: 4px;
  }
  .ant-calendar-picker.warn .anticon-calendar {
    color: #e54506;
  }

  .form-text-info-more {
    text-decoration: none;
    color: #0295ee;
  }
  .init-message {
    margin: 2px 0 0;
  }
}
.sampleModal {
  .ant-modal-footer {
    display: none;
  }
}
.form-text-info-more {
  text-decoration: none;
  color: #0295ee;
}
.upload-list-detail .anticon-close {
  display: none;
}
</style>

